import { useMemo, useCallback } from 'react';
import { Pages } from '../Core/Enums';
import {
	LoaderButton,
	Props as LoaderButtonProps,
} from '../Core/Components/Inputs/LoaderButton/LoaderButton';

import { FooterContainer } from '../Core/Components/Footer/Footer';

import { ProductionOrdersTable } from './ProductionOrdersTable/ProductionOrdersTable';
import { useProductionOrdersTableData } from './ProductionOrdersTable/useProductionOrdersTableData';
import { Header } from '../Core/Components/Header/Header';
import { DatePicker } from '../Core/Components/MiniDatePicker/MiniDatePicker';
import { Printable } from '../Core/Components/Printable/Printable';

import './ProductionOrdersPage.scss';
import { PerformantPrintable } from '../Core/Components/PerformantPrintable/PerformantPrintable';

export const ProductionOrdersPage = () => {
   // Get the data for the table
    const tableData = useProductionOrdersTableData();
   
    // Get the state for the refresh button
    const refreshButtonState: LoaderButtonProps['state'] = useMemo(() => {
        return tableData.isFetching ? 'loading' : 'idle';
    }, [tableData.isFetching]);

    // Handler for the refresh button
    const handleRefresh = useCallback(() => {
        tableData.refresh();
    }, [tableData]);

    return (
        <div className="production-orders-page">
            <div className="store-order-page__header">
            <Header 
                    page={Pages.ORDERBOOK_PRODUCTION_PAGE}
                    button={
                       <LoaderButton state={refreshButtonState} onClick={handleRefresh} />
                    }
                >
                    <PerformantPrintable
                        baseClass="store-order-page"
                        isLoading={tableData.isLoading}
                    />
                    <DatePicker />
                </Header>
            </div>

            <div className="store-order-page__content">
                <ProductionOrdersTable 
                    {...tableData} 
                />
            </div>
            <div className="store-order-page__footer">
				<FooterContainer page={Pages.ORDERBOOK_PRODUCTION_PAGE} />
			</div>
        </div>
    );
};

const noop = () => {};